import { render } from "./TheHintModal.vue?vue&type=template&id=7e0a43d8"
import script from "./TheHintModal.vue?vue&type=script&lang=js"
export * from "./TheHintModal.vue?vue&type=script&lang=js"
script.render = render

export default script